import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   LinkIcon,
// } from '../../components'
import Styles from './IyvListSearchBar.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListSearchBar extends Component {
  static propTypes = {
    currentTutorial: PropTypes.number,
    showTutorial: PropTypes.bool,
    clickCloseTutorial: PropTypes.func,
    onSearchInputChange: PropTypes.func,
    searchInput: PropTypes.string,
    handleKeyPress: PropTypes.func,
    clickSearch: PropTypes.func
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <div
      styleName={
        this.props.currentTutorial === 0 && this.props.showTutorial ?
          'search tutorial-highlight-search' :
          'search'
      }
    >
      <div styleName='search-input-wrap'>
        <input
          onClick={this.props.clickCloseTutorial}
          onChange={this.props.onSearchInputChange}
          value={this.props.searchInput}
          onKeyPress={this.props.handleKeyPress}
          styleName='search-input'
          type='text'
          placeholder='Search funds' //  by name, ticker, or manager
        />
        <button
          styleName='search-button'
          onClick={
            () => {
              this.props.clickSearch()
              this.props.clickCloseTutorial()
            }
          }
          role='button'
          tabIndex='0'
        >
          <i
            styleName='search-button-icon'
            className='fa fa-search'
          />
        </button>
      </div>
    </div>
  }
}

